import {
  Component,
  input,
  output,
} from '@angular/core'
import { StringRecord } from '../shared/models/general'
import { ValidationMessage } from './entity-metadata'
import { EditableTableToolbarButtonComponent } from './editable-table-toolbar-button.component'
import { ValidationMessageViewerComponent } from './validation-message-viewer.component'

@Component({
  selector: 'app-editable-table-toolbar',
  imports: [
    EditableTableToolbarButtonComponent,
    ValidationMessageViewerComponent,
  ],
  template: `
    <button
        app-editable-table-toolbar-button
        btnType='success'
        class='me-2'
        title='Add new'
        icon='add'
        [disabled]="addNewDisabled()"
        (click)="addNew.emit()"
    >
    </button>
    <button
        app-editable-table-toolbar-button
        class='me-2'
        icon='undo'
        [disabled]="undoDisabled()"
        (click)="undo.emit()"
        title='Undo all changes'
    >
    </button>
    <button
        app-editable-table-toolbar-button
        btnType='primary'
        class='me-2'
        label='Save'
        [disabled]="saveDisabled()"
        (click)="save.emit()"
    >
    </button>
    @if(validationMessages().length > 0) {
      <app-validation-message-viewer
          [validationMessages]="validationMessages()"
          [labels]="labels()"
          (messageClick)="messageClick.emit($event)"
      />
    }
  `,
  styles: `
    :host {
      display: flex;

      app-validation-message-viewer {
        flex-basis: 0;
        flex-grow: 1;
      }
    }
  `,
})
export class EditableTableToolbarComponent {
  readonly addNewDisabled = input.required<boolean>()
  readonly undoDisabled = input.required<boolean>()
  readonly saveDisabled = input.required<boolean>()
  readonly labels = input.required<StringRecord>()
  readonly validationMessages = input.required<readonly ValidationMessage[]>()

  readonly addNew = output()
  readonly undo = output()
  readonly save = output()
  readonly messageClick = output<ValidationMessage>()
}
